export const CONSENT_MODAL_CREATED = 'consent_modal_created';
